(function () {
  if (window.__mtScriptsInit) return;
  window.__mtScriptsInit = true;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-mt-count]');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var run = function (el) {
      var target = parseFloat(el.getAttribute('data-mt-count'));
      var suffix = el.getAttribute('data-mt-suffix') || '';
      if (reduce || isNaN(target)) {
        el.textContent = target + suffix;
        return;
      }
      var start = null;
      var duration = 1400;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    };
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            run(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initFaq() {
    var items = document.querySelectorAll('.mt-faq-item');
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('.mt-faq-pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('mt-faq-open');
        items.forEach(function (i) { i.classList.remove('mt-faq-open'); });
        if (!isOpen) item.classList.add('mt-faq-open');
      });
    });
  }

  function initVariantPicker() {
    var forms = document.querySelectorAll('[data-mt-comprar]');
    forms.forEach(function (form) {
      var radios = form.querySelectorAll('input[name="mt-variante"]');
      var priceEl = form.querySelector('[data-mt-precio]');
      var compareEl = form.querySelector('[data-mt-precio-comparado]');
      var variantInput = form.querySelector('input[name="id"]');
      if (!radios.length) return;
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          variantInput.value = radio.value;
          if (priceEl) priceEl.textContent = radio.getAttribute('data-precio');
          if (compareEl) {
            var cmp = radio.getAttribute('data-precio-comparado');
            if (cmp) {
              compareEl.textContent = cmp;
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }
          form.querySelectorAll('.mt-plan').forEach(function (p) { p.classList.remove('mt-plan-activo'); });
          radio.closest('.mt-plan').classList.add('mt-plan-activo');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initFaq();
    initVariantPicker();
  });
})();
